module.exports = __webpack_public_path__ + "static/media/threatcop-logo.8b68deab.png";